import React from "react";
import { useNavigate } from "react-router-dom";

const ModernSurveyCard = ({
  survey,
  index,
  onSelect,
  onCopyLink,
  totalVotes = 0,
  targetVotes = 100
}) => {
  const navigate = useNavigate();

  // Assign colors based on index or survey status
  const colorVariants = ['mint', 'blue', 'green', 'orange', 'red'];
  const cardColor = colorVariants[index % colorVariants.length];

  // Calculate progress percentage
  const progressPercentage = totalVotes > 0
    ? Math.min((totalVotes / targetVotes) * 100, 100)
    : 0;

  // Get survey status
  const getSurveyStatus = () => {
    if (progressPercentage >= 100) return 'completed';
    if (progressPercentage > 0) return 'active';
    return 'paused';
  };

  const status = getSurveyStatus();

  const handleCardClick = () => {
    if (survey.user_role === "manager") {
      onSelect(index);
    }
  };

  const handleResultsClick = (e) => {
    e.stopPropagation();
    window.open(`/results/${survey.surveyId}`, '_blank');
  };

  const handleCopyLink = (e) => {
    e.stopPropagation();
    onCopyLink(survey.surveyId);
  };

  return (
    <div
      className={`survey-card-modern ${cardColor}`}
      onClick={handleCardClick}
      style={{ cursor: survey.user_role === "manager" ? 'pointer' : 'default' }}
    >
      {/* Card Header */}
      <div className="survey-card-modern-header">
        <span className={`survey-status-badge ${status}`}>
          {status}
        </span>
      </div>

      {/* Card Body */}
      <div className="survey-card-modern-body">
        <h3 title={survey.surveyName || 'Untitled Survey'}>
          {survey.surveyName || 'Untitled Survey'}
        </h3>
        <p>ID: {survey.surveyId}</p>

        {/* Progress Bar */}
        <div className="survey-progress">
          <span className="survey-progress-label">Progress</span>
          <div className="survey-progress-bar">
            <div
              className="survey-progress-fill"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
          <span className="survey-progress-text">
            {totalVotes} / {targetVotes} votes
          </span>
        </div>
      </div>

      {/* Card Footer - Simplified with just buttons */}
      <div className="survey-card-modern-footer">
        <div className="survey-footer-buttons">
          {survey.user_role === "manager" && (
            <button
              className="survey-action-btn copy-link"
              onClick={handleCopyLink}
              title="Copy Vote Link"
            >
              Copy Link
            </button>
          )}
          <button
            className="survey-action-btn"
            onClick={handleResultsClick}
            title="View Results"
          >
            View Results
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModernSurveyCard;
